export default __webpack_public_path__ + "static/vos-evan-877834b4a2e0b3025b6c2a0248836671.mp4";